import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { CadsSpinnerConfig, CadsSpinnerSize } from './cads-spinner.config';

/** Number of dot arms in the legacy loader animation. */
const CADS_SPINNER_ARM_COUNT = 18;

/**
 * Centered loading indicator using the legacy Brightside dot-chase animation (migrated from `bw-spinner-legacy`).
 * Optional caption and `role="status"` for assistive tech.
 */
@Component({
  selector: 'cads-spinner',
  standalone: true,
  templateUrl: './cads-spinner.component.html',
  styleUrl: './cads-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'cads-spinner-host',
  },
})
export class CadsSpinnerComponent {
  readonly config = input<CadsSpinnerConfig>({});

  protected readonly _arms = Array.from({ length: CADS_SPINNER_ARM_COUNT }, (_, index) => index);

  protected readonly _size = computed((): CadsSpinnerSize => this.config().size ?? 'medium');

  protected readonly _color = computed(
    () => this.config().color?.trim() || 'var(--cads-color-blue)'
  );

  protected readonly _accessibleLabel = computed(() => {
    const fromConfig = this.config().accessibleLabel;
    if (fromConfig !== undefined) {
      const trimmed = fromConfig.trim();
      return trimmed.length > 0 ? trimmed : null;
    }
    return 'Loading';
  });

  protected readonly _label = computed(() => this.config().label?.trim() || null);
}
